import { css } from '@emotion/css';
import cls from 'classnames';

const boxShadow = css`
  box-shadow: 0 8px 40px rgba(63, 63, 63, 0.2);
`;

const styles = {
  wrapper: (isNavOpen: boolean) =>
    cls(
      `z-30 flex flex-col max-h-screen items-stretch teair:bg-white tesn:bg-black teds:bg-eds-black tels:bg-black py-2 xl:py-0 ${boxShadow}`,
      isNavOpen
        ? 'fixed top-0 left-0 w-screen h-screen bg-black safari-100vh-hack'
        : `sticky ${boxShadow}`,
    ),
  contentContainer:
    'flex flex-shrink-0 justify-between items-center xl:py-4 px-4 xl:px-6 relative',
  energyLogoWrapper: (isLiveSessionEvent = false) =>
    cls(
      'flex-grow-0 pr-4',
      isLiveSessionEvent && 'fixed top-3',
      'xl:teair:fixed xl:teair:top-3',
      'xl:tesn:fixed xl:tesn:top-3',
    ),
  iconsWrapper:
    'flex flex-grow flex-shrink-0 min-w-max justify-end items-center',
  navigation:
    'overflow-y-auto bg-white fixed h-screen top-16 z-50 w-full tesn:bg-black teds:bg-eds-black tels:bg-black',
};

export default styles;
